/**
 * @generated SignedSource<<894e6cf8f3f21d5f7ce7b3b186f17c0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type videoShortCarouselPlayerContent$data = {
  readonly entityId?: string;
  readonly headline?: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"actionWidgetContent" | "entityLink" | "helpersGetVideoYoutubeIdVideo" | "shareArticle20Content">;
  readonly " $fragmentType": "videoShortCarouselPlayerContent";
};
export type videoShortCarouselPlayerContent$key = {
  readonly " $data"?: videoShortCarouselPlayerContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"videoShortCarouselPlayerContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "videoShortCarouselPlayerContent",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headline",
          "storageKey": null
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "helpersGetVideoYoutubeIdVideo",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "youtubeId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VideoSource",
              "kind": "LinkedField",
              "name": "videoSource",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "type": "Video",
      "abstractKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "actionWidgetContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "shareArticle20Content"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "127c7a764eabc0117298845a80565a3b";

export default node;
